<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style src="./assets/styles/main.scss" lang="scss"></style>
